<!--
 * @Description:
 * @Date: 2019-09-02 09:48:51
 -->

<!--用户管理-->
<template>
  <div class="table-box">
    <div
      style="margin-bottom:15px;color:#666;text-align:left;display:flex;justify-content:space-between;"
    >
      <span style="color:red;">
        【项目支付金额】计算公式为：终端结算金额×（1+服务费率）。说明：服务费率是完税成本。项目支付金额为所有终端结算金额总和
      </span>
      <!-- <span>项目支付金额：<b>9800000000.00元</b></span> -->
    </div>
    <!--列表-->
    <div class="">
      <el-table
        v-loading="loading"
        :data="tableData"
        border=""
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="false"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskDt"
          label="任务月度"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="supplieName"
          label="供应商"
        >
          <template slot-scope="{ row }">
            <div style="display:flex;">
              <div
                style="max-width:90%;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;margin-right:8px;"
              >
                {{ row.supplieName }}
              </div>
              <el-popover placement="top-start" trigger="hover">
                <el-table :data="row.rateList">
                  <el-table-column
                    width="200"
                    property="date"
                    label="服务费发放区间（自然人）"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.startPrice | moneyFixed }}—{{
                        +scope.row.endPrice | moneyFixed
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="140"
                    property="name"
                    label="服务费率（%）"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.sumScale | transScale }}
                    </template>
                  </el-table-column>
                </el-table>
                <img
                  src="http://cdn.yxvzb.com/WEB/SaaS/images/info.png"
                  slot="reference"
                  class="info"
                />
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="终端结算金额"
        >
          <template slot-scope="{ row }">
            {{ row.projectPayPrice | moneyFixed }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="项目支付金额"
        >
          <template slot-scope="scope">
            {{ scope.row.initProjectPrice | moneyFixed }}
          </template>
        </el-table-column>
        <template>
          <el-table-column align="center" label="操作">
            <template slot-scope="{ row }">
              <el-button
                :disabled="row.payStatus !== 2"
                type="text"
                @click="downloadFile(row)"
              >
                下载回单
              </el-button>
            </template>
          </el-table-column>
        </template>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="支付状态"
          v-if="type != 1"
        >
          <template slot-scope="scope">{{ scope.row.projectNo }}</template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="支付时间"
          v-if="type != 1"
        >
          <template slot-scope="scope">{{ scope.row.projectNo }}</template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="供应商到账状态"
          v-if="type != 1"
        >
          <template slot-scope="scope">{{ scope.row.projectNo }}</template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="到账时间"
          v-if="type != 1"
        >
          <template slot-scope="scope">{{ scope.row.projectNo }}</template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="终端到账状态"
          v-if="type != 1"
        >
          <template slot-scope="scope">{{ scope.row.projectNo }}</template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="终端到账金额"
          v-if="type != 1"
        >
          <template slot-scope="scope">{{ scope.row.projectNo }}</template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>-->
    </div>
  </div>
</template>

<script>
// import datePicker from "@/Mixin/datePicker";
import { projectPayDetail, alreadyDownBack } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { makeSure } from '@/Mixin/makeSure';
export default {
  inject: ['itemData'],
  mixins: [pageInation, makeSure],
  data() {
    return {
      ruleForm: {
        taskDate: ''
      },
      getList: projectPayDetail, // 获取列表的AJAX
      searchQuery: {
        csoOrderId: this.itemData.data.id
      }
    };
  },
  props: {
    type: {
      default: 1
    }
  },
  components: {},
  computed: {
    myrouter() {
      return this.$route.query.activeTask;
    },
    ancestorItem() {
      return this.itemData.data;
    }
  },
  methods: {
    downloadFile(row) {
      //入参:String payOrderNo（订单号）,Long projectId,String taskDt,Long supplierId(供应商id)
      try {
        let a = JSON.parse(localStorage.getItem('activeTask')) || {};
        let { orderSupplierId, taskDt } = row;
        let { projectName } = a;
        projectName = projectName || '';
        window.open(
          `${alreadyDownBack}?orderSupplierId=${orderSupplierId}&projectName=${projectName}&taskDt=${taskDt}`
        );
      } catch (e) {
        console.error(e);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.info {
  width: 12px;
  height: 12px;
}
</style>
